/** @jsxImportSource @emotion/react */
"use client";

import { Box, Typography, Button } from "@mui/material";
import Image from "next/image";
import { aboutContainer, textSection, imageSection } from "./styles";

export default function HomeAboutPreview() {
  return (
    <Box css={aboutContainer}>
      <Box css={textSection}>
        <Typography variant="h2" color="primary.main" gutterBottom>
          Hammaddeden Sanata
        </Typography>
        <Typography variant="body1" mb={2}>
          Famento Design, el yapımı beton tasarımlarıyla yaşam alanlarınıza
          sıcaklık ve estetik kazandırmak için yola çıktı.
        </Typography>
        <Typography variant="body1" mb={4}>
          Terrazzonun büyüleyici dokusu, doğal taşlar, pigmentler ve sade
          formlarla her biri özenle yapılan özel ürünler üretiyoruz.
        </Typography>
        <Button href="/hakkimizda" variant="outlined">
          Daha Fazlası
        </Button>
      </Box>

      <Box css={imageSection}>
        <Image
          src="/images/home-about.JPEG"
          alt="Famento tasarımları"
          fill
          priority
        />
      </Box>
    </Box>
  );
}
